import { TenantEnum } from '@jsmdg/tenancy';
import { type TenantConfig } from '../shared/types/tenantConfig';

enum BrandName {
    JochenSweizer = 'Jochen Schweizer',
    MyDays = 'mydays',
}

const corporateFormDescription =
    'Gerne beantworten wir alle Ihre Fragen zu den Erlebnissen für Firmen von ';

const jsdeConfig: TenantConfig = {
    corporateFormDescription: `${corporateFormDescription}Jochen Schweizer.`,
    currency: { code: 'EUR', symbol: '€' },
    brandName: BrandName.JochenSweizer,
    contactInfo: { phone: { label: '', number: '' } },
    urls: {
        b2bContact: '',
        redeemVoucher: '',
        privacyPolicy: '',
        contact: '',
        redemption: '',
        newsletterUnsubscribe: '',
    },
    tenantContacts: {
        at: {
            label: '',
            number: '',
        },
        de: {
            label: '',
            number: '',
        },
        ch: {
            label: '',
            number: '',
        },
    },
};

const mdDEConfig: TenantConfig = {
    ...jsdeConfig,
    corporateFormDescription: `${corporateFormDescription}mydays.`,
    brandName: BrandName.MyDays,
};

/**
 * @TODO update mydays config
 */
const tenantConfigMapping: Record<string, TenantConfig> = {
    [TenantEnum.JS_DE]: jsdeConfig,
    [TenantEnum.JS_AT]: jsdeConfig,
    [TenantEnum.MD_DE]: mdDEConfig,
    [TenantEnum.MD_AT]: mdDEConfig,
    [TenantEnum.MD_CH]: {
        ...mdDEConfig,
        currency: { code: 'CHF', symbol: 'CHF' },
    },
};

const getTenantConfig = (tenant: TenantEnum): TenantConfig => {
    return tenantConfigMapping[tenant] || tenantConfigMapping[TenantEnum.JS_DE];
};

export { getTenantConfig };
